const getEnhancedMessageValues = () => ({
  b: <b />,
  i: <i />,
  u: <u />,
  error: <span className="error-text" />,
  br: <br />,
});

export default getEnhancedMessageValues;
